import { addDays } from 'date-fns';

import type { IPlanName } from '@app/dashboard/types/innerLayout/reach/bundles';
import { EMPTY_VALUE } from '@app/dashboard/constants/shared';
import type {
  ICampaignAnalysis,
  ISingleCampaignStatics,
} from '@app/dashboard/types/innerLayout/reach';
import { formatToISODate } from '@app/dashboard/utils/dateFormats';

export const singleCampaignRenderBox = ({
  key,
  campaignStaticsData,
}: {
  key: keyof ISingleCampaignStatics | keyof ICampaignAnalysis;
  campaignStaticsData: {
    data: { data: ISingleCampaignStatics | ICampaignAnalysis };
  };
}) => {
  const data = campaignStaticsData?.data?.data;

  if (data && key in data) {
    return data[key as keyof typeof data] ?? EMPTY_VALUE;
  } else {
    return EMPTY_VALUE;
  }
};

export const getPlanName = (
  data: {
    plan: IPlanName;
  },
  lang: 'en' | 'ar'
) => {
  return lang === 'en' ? data?.plan?.name_en : data.plan?.name_ar;
};

export const getPlanExpireDate = (expireIn: number) => {
  return formatToISODate(addDays(new Date(), expireIn));
};
